$(".close-wrapper").find("i").on("click",(function(){$(".popup-outer").addClass("hidden")}));